<!--
 * @Author: kongxiangyu
 * @Date: 2022-12-07 14:26:46
 * @LastEditTime: 2023-02-09 13:11:20
 * @email: kongxiangyu@cd.baidu.com
 * @Description: Do not edit
-->
<template>
    <div
        :class="[name,isHide ? 'hide' : 'show']"
        :style="{backgroundImage: 'url(' + buttonUrl + ')'}"
        @click="handleClick"
    ></div>
</template>

<script>

export default {
    props: {
        name: {
            type: String,
            default: ''
        },
        buttonUrl: {
            type: String,
            default: ''
        },
        top: {
            type: Number,
            default: 0
        },
        width: {
            type: Number,
            default: 0
        },
        height: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            timer: null,
            isHide: false
        };
    },

    watch: {},
    created() {
        window.addEventListener('scroll', this.onScroll, {
            passive: true
        });
    },
    mounted() {
    },
    methods: {
        handleClick() {
            this.$emit('handleClickFloatBtn');
        },
        onScroll() {
            this.isHide = true;
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.isHide = false;
            }, 1000);
        }
    }
};
</script>
<style lang='scss' scoped>
.float-btn-ms {
    background-size: 100% 100%;
    position: fixed;
    z-index: 100;
    transition: all .08s ease-in-out;
    width:60px;
    height:60px;
    top:78vh
}
.float-btn-package {
    background-size: 100% 100%;
    position: fixed;
    z-index: 100;
    transition: all .08s ease-in-out;
    width:79px;
    height:91px;
    top:68.5vh;
}
@media only screen and (min-aspect-ratio: 3/5){
	.float-btn-ms{
        top:80vh;
    }
    .float-btn-package{
        top:66vh;
    }
}
.hide {
    right: -35px;
    opacity: 0.5;
}

.show {
    right: 0;
}
</style>